import { Component, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Color } from 'src/app/config/color';
import { passwordAllowedSpecialCharacters } from 'src/app/config/security-config';
import { RoutingDataService } from 'src/app/submodules/angular-common/routing-data.service';
import { SecurityDataService } from 'src/app/submodules/angular-common/security-data.service';
import { navigateToSamePage } from 'src/app/submodules/angular-common/util';
import { FileDto } from '../../../base-types';
import { FormSettings } from '../../../forms/form-settings';
import { PageFormComponent } from '../../../forms/page-form.component';
import { NotificationDataService } from '../../../notification-data.service';

@Component({
  selector: 'app-set-or-reset-password-step2',
  templateUrl: './set-or-reset-password-step2.component.html',
  styleUrls: ['./set-or-reset-password-step2.component.scss']
})
export class SetOrResetPasswordStep2Component extends PageFormComponent {

  public bgColor = Color.auxiliary;
  public submitDone:boolean = false; //true se effettuato almeno un submit e quindi viene mostrato il messaggio di feedback

  passwordAllowedSpecialCharactersAsStr = passwordAllowedSpecialCharacters.join('');

  constructor(protected _injector: Injector){
    super(_injector);
  }

  ngOnInit(): void {
    this.init()
  }

  /** @override */
  async init() {
    console.log('SetOrResetPasswordStep2Component ngOnInit()');
    await super.init()
    //Call check-otp endpoint
    const result = await(this._injector.get(SecurityDataService).checkOtp(this._injector.get(RoutingDataService).currentUrlParams.otp as string));
    
    if(!result){
       this._injector.get(NotificationDataService).openSnackBar(this._injector.get(TranslateService).instant("AUTH.INVALID_OTP"));
       this._injector.get(Router).navigate(['/']);
    }
  }

  /** @override */
  protected async _initSettingsHook(): Promise<FormSettings> {
    return {
      fieldsSettings: {
        password: { required: true, allowBlanks: false },
        passwordConfirmation: { required: true, allowBlanks: false }
      }
    }
  }

  /** @override */
  protected async _setDatasourceHook(): Promise<{ [key: string]: string | number | boolean | (string | number)[] | File | File[] }> {
    return {}
  }

  /** @override */
  protected async _submitHook() {

      //TODO:capire
      if(this.currentValues.password !=this.currentValues.passwordConfirmation){

      }

     //ritorna sempre 200 anche in caso di username non esistente per motivi di sicurezza

     try {
      if(this._injector.get(RoutingDataService).currentRoutingNodeId=='set_password')
        await this._injector.get(SecurityDataService).setPassword(this._injector.get(RoutingDataService).currentUrlParams.otp as string,
                                                                   this.currentValues.password as string,
                                                                   this.currentValues.passwordConfirmation as string);
      else
        await this._injector.get(SecurityDataService).passwordReset(this._injector.get(RoutingDataService).currentUrlParams.otp as string,
          this.currentValues.password as string,
          this.currentValues.passwordConfirmation as string);

       this._injector.get(NotificationDataService).openSnackBar(this._injector.get(TranslateService).instant("FORM.SUCCESSFUL_OPERATION"));
       
       this._injector.get(Router).navigate(['/']);
     } catch (error) {
       console.log('error :>> ', error);
       console.log('error :>> ', JSON.stringify(error));
       console.log('error.error.errorCode :>> ', error.error.errorCode);
       //Se 513 con error.code=OTP-NOT-VALID navighiamo su step1
        // errorCode: "AUTH.UNMATCHING_PASSWORD_CONFIRMATION"
        // message: "unmatching password confirmation"
        // path: "/auth/api/v1/reset-password"
        // status: 513
        // timeStamp: "2020-12-04T20:58:11.046Z"
        // type: "Generic Error"
        if(error.error.errorCode == 'AUTH.INVALID_OTP'){
          const url = this._injector.get(RoutingDataService).currentRoutingNodeId=='set_password'?'/set-password':'/reset-password';
          //triangolare per ricaricare la pagina
          navigateToSamePage(this._injector, url)
        }
        throw error; //in tutti i casi mostriamo il growl
     }
     
     this.submitDone = true
  }

  async cancel(){
    this._injector.get(Router).navigate(['/']);
  }
}
